import { render, staticRenderFns } from "./ProductFilter.vue?vue&type=template&id=2faa731e&scoped=true"
import script from "./ProductFilter.vue?vue&type=script&lang=js"
export * from "./ProductFilter.vue?vue&type=script&lang=js"
import style0 from "./ProductFilter.vue?vue&type=style&index=0&id=2faa731e&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2faa731e",
  null
  
)

export default component.exports